import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import { Checklist } from 'src/app/models/checklist.model';
import { Declaration } from 'src/app/models/declaration.model';
import { Party } from 'src/app/models/party.model';
import { CommonService } from 'src/app/services/common.service';
import { constants } from 'src/app/utils/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-declaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.scss'],
  standalone: false
})
export class DeclarationComponent  implements OnInit, AfterViewInit {

  public accessibleMode: string = '';
  public parties: Party[] = [];
  public declarationInfo: any = [];
  public isValid: boolean = false;
  public checkItem: any = [];
  public emailSender: string = '';
  public message: string = '';
  public itemId: string = '';
  public reCaptchaSiteKey = environment.reCaptchaSiteKey;
  public reCaptchaApproved: boolean = false;
  public reCaptchaTokenSubject = new BehaviorSubject<string | null>(null);
  public reCaptchaTokenSubs = this.reCaptchaTokenSubject.asObservable();

  constructor(
    private commonService: CommonService,
    private navController: NavController,
    private router: Router,
  ) { }

 async ngOnInit() {
    this.commonService.getSourceOfData().subscribe((message) => this.declarationInfo = message);

    if (this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].itemId) {
      this.accessibleMode = this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].accessibleMode;
      this.itemId = this.router?.getCurrentNavigation()?.extras.state?.[constants.QUERY_PARAMS].itemId;      
      const checkItem: Checklist = await this.commonService.getItem(this.itemId);

      if (checkItem != null) {
        this.checkItem = checkItem;
        this.cricketValidtion();
        this.commonService.setCurrentMode(this.accessibleMode, this.checkItem);
        this.editDeclarationInfo();
      }
    } else {
      this.navController.navigateForward(constants.PAGE.ORGANISATION);
    }
    this.commonService.pushCurrentTabPosition(5);
  }

  ngAfterViewInit(): void {
    if (this.accessibleMode != constants.VIEW) {
      setTimeout(() => {
        this.renderReCaptcha();
      }, 1000);
    }
    
    this.reCaptchaTokenSubs.subscribe(token => {
      if (token) {
        this.reCaptchaApproved = true;
      } else {
        this.reCaptchaApproved = false;
      }
    });
  }

  public async editDeclarationInfo() {
    if (JSON.stringify(this.checkItem.parties) !== '{}') {
      this.parties = this.checkItem.parties;
      //var homeTeamRepresentativeTyp = this.parties[0].type?.toLocaleLowerCase();
      var partyInfo = this.checkItem.parties;
      const homeTeamRepresentative = partyInfo[1];
      const awayTeamRepresentative = partyInfo[3];
      this.declarationInfo = {
        submissionDateTime: this.commonService.getCurrentDate(),
        homeTeamRepresentativeName: homeTeamRepresentative[Object.keys(homeTeamRepresentative)[1]] || constants.EMPTY,
        homeTeamRepresentativePosition: homeTeamRepresentative[Object.keys(homeTeamRepresentative)[2]] || constants.EMPTY,
        awayTeamRepresentativeName: awayTeamRepresentative[Object.keys(awayTeamRepresentative)[1]] || constants.EMPTY,
        awayTeamRepresentativePosition: awayTeamRepresentative[Object.keys(awayTeamRepresentative)[2]] || constants.EMPTY,
        email: (homeTeamRepresentative[Object.keys(homeTeamRepresentative)[3]] + ',' + awayTeamRepresentative[Object.keys(awayTeamRepresentative)[3]]),
        weAreAuthorisedRepresentatives: false,
        weDeclareThatAfterReasonableInquiry: false,
        inspectionMatchDayChecklistCompleted: false
      };

      if (JSON.stringify(this.checkItem.declaration) !== '{}') {
        var declare = this.checkItem.declaration;
        this.declarationInfo.weAreAuthorisedRepresentatives = this.commonService.checkIfNullOrUndefined(declare.weAreAuthorisedRepresentatives) ? false : declare.weAreAuthorisedRepresentatives;
        this.declarationInfo.weDeclareThatAfterReasonableInquiry = this.commonService.checkIfNullOrUndefined(declare.weDeclareThatAfterReasonableInquiry) ? false : declare.weDeclareThatAfterReasonableInquiry;
        this.declarationInfo.inspectionMatchDayChecklistCompleted = this.commonService.checkIfNullOrUndefined(declare.inspectionMatchDayChecklistCompleted) ? false : declare.inspectionMatchDayChecklistCompleted;
      }
    }
  }

  public async submitDeclartion() {
    this.cricketValidtion();
    if (this.isValid) {
      if (this.declarationInfo.weAreAuthorisedRepresentatives === true
        && this.declarationInfo.weDeclareThatAfterReasonableInquiry === true
        && this.declarationInfo.inspectionMatchDayChecklistCompleted === true) {

        this.commonService.pushCurrentTabPosition(0);
        let navigationExtras: NavigationExtras = {
          state: {
            queryParams: {
              accessibleMode: this.accessibleMode,
              itemId: this.itemId
            }
          }
        };
        let emailAddrees = '';
        // for (let item of this.checkItem) {
        //   const party = item.parties;
        //   if (party[Object.keys(party)[3]]) {
        //     emailAddrees += party[Object.keys(party)[3]] + ','
        //   }
        // }
        for (let index = 0; index < this.checkItem.parties.length; index++) {
          const party = this.checkItem.parties[index];
          if (party[Object.keys(party)[3]]) {
            emailAddrees += party[Object.keys(party)[3]] + ','
          }
        }
        this.emailSender = emailAddrees.slice(0, -1);
        this.declarationInfo.email = this.emailSender;
        if (this.accessibleMode === constants.NEW || this.accessibleMode === constants.EDIT) {
          let processId = await this.commonService.insertChecklistItem(this.itemId, constants.DECLARATION, this.declarationInfo, this.declarationInfo.email, true);
          if (processId == this.itemId) {
            this.navController.navigateForward(constants.PAGE.CHECKLIST, navigationExtras).then(() => {
              this.commonService.clearAllLocalstorage();         
              //location.reload();    
            });
            alert(constants.MESSAGE.SUBMITTED);
          } else if (processId !== this.itemId) {
            this.navController.navigateForward(constants.PAGE.CHECKLIST, navigationExtras).then( () => {
              this.commonService.clearAllLocalstorage();                
              ////location.reload();
            });
            alert(constants.MESSAGE.PROCESSED);
          }
        } else {
          this.navController.navigateBack(constants.PAGE.CHECKLIST, { replaceUrl: true }).then( () => {
           this.commonService.clearAllLocalstorage();  
           ////location.reload();        
          });
        }
      }
    }
  }

  public cricketValidtion() {
    this.isValid = false;
    if (JSON.stringify(this.checkItem) === '{}') {
      alert(constants.MESSAGE.FILL_ALL);
      this.navController.navigateForward(constants.PAGE.ORGANISATION);
    } else if (JSON.stringify(this.checkItem.organisation) === '{}') {
      alert(constants.MESSAGE.FILL_ORGANISATION);
      this.navController.navigateForward(constants.PAGE.ORGANISATION);
    } else if (JSON.stringify(this.checkItem.address) === '{}') {
      alert(constants.MESSAGE.FILL_ADDRESS);
      this.navController.navigateForward(constants.PAGE.ADDRESS);
    } else if (JSON.stringify(this.checkItem.parties) === '{}') {
      alert(constants.MESSAGE.FILL_PARTIES);
      this.navController.navigateForward(constants.PAGE.PARTIES);
    } else if (JSON.stringify(this.checkItem.risk) === '{}') {
      alert(constants.MESSAGE.FILL_RISK);
      this.navController.navigateForward(constants.PAGE.RISK);
    } else {
      this.isValid = true;
    }
  }

  public backToPage() {
    this.commonService.pushCurrentTabPosition(2);
    let navigationExtras: NavigationExtras = {
      state: {
        queryParams: {
          accessibleMode: this.accessibleMode,
          itemId: this.itemId
        }
      }
    };
    this.navController.navigateBack(constants.PAGE.RISK, navigationExtras);
  }

  public renderReCaptcha() {
    if (typeof (window as any).grecaptcha != 'undefined') {
      (window as any).grecaptcha.render('recaptcha', {
        sitekey: this.reCaptchaSiteKey,
        callback: (token: string) => {
          this.reCaptchaTokenSubject.next(token);
        }, 'expired-callback': () => {
          this.reCaptchaTokenSubject.next(null);
        }
      });
    } else {
      this.reCaptchaTokenSubject.next(null);
    }
  }
  
}
